import { CAMERA_PRESENTER } from '@shoflo/polymer/constants/SourceItems';
import { MAX_AGORA_CAMERA_COUNT } from '@studio/constants/Sources';
import { toggleAgoraAttendeeMuteStatus } from '@shoflo/studio-redux/actions';
import toggleAgoraAttendeeCameraStatus from '@shoflo/studio-redux/actions/attendee/toggleAgoraAttendeeCameraStatus';
import takeGenericPresenterLive from '@shoflo/studio-redux/actions/source/takeGenericPresenterLive';
import setProgram from './setProgram';
import { StudioLogger } from '@studio/logger/StudioLogger';

import { showNotification } from '../index';

const logger = new StudioLogger('presenter-live-toggle');

function toggleAgoraPresenterLive() {
  return (dispatch, getState) => {
    const {
      meeting: { attendeeResponse },
      user,
      program,
      broadcastSources
    } = getState();

    const { AttendeeId } = attendeeResponse.Attendee;

    const presenterIsLive = program.layers.some(
      layer => layer.source.value === AttendeeId
    );

    const source = broadcastSources.sources.find(s => s.value === AttendeeId);
    const cameraPresenterCount = program.layers.filter(
      layer => layer.source.type === CAMERA_PRESENTER
    );

    if (
      !presenterIsLive &&
      cameraPresenterCount.length >= MAX_AGORA_CAMERA_COUNT
    ) {
      dispatch(
        showNotification(
          `You're at the max of ${MAX_AGORA_CAMERA_COUNT} sources available at a time in program.`,
          { timeout: 3500, type: 'alert' }
        )
      );
      return;
    }
    const title = `Presenter ${user?._id} toggle live state. Previously ${presenterIsLive}`;
    logger.info(title, {});

    dispatch(
      takeGenericPresenterLive(
        source,
        {},
        setProgram,
        toggleAgoraAttendeeCameraStatus,
        toggleAgoraAttendeeMuteStatus
      )
    );
  };
}

export default toggleAgoraPresenterLive;
